import Template from './template';
import Util from './util';
import Nodes from './config/nodes';

Template.add('notification.simple',
    `<div class="notification">{{text}}</div>`);

Template.add('notification.icon',
    `<div class="notification notification_icon">
        <div class="notification__icon lnr lnr-{{icon}}"></div>
        {{text}}
    </div>`);

const getBEMNote = (el, mod) => Util.getBEM('notification', el, mod);
const cls = Util.cls;
const config = {
    sel: {
        base: getBEMNote(),
        visible: getBEMNote(null, 'visible')
    },
    iconMappings: {
        error: 'cross-circle',
        warning: 'warning',
        success: 'checkmark-circle'
    }
};

function show(text, icon = null) {
    if(!text || !text.length) return;

    icon = config.iconMappings[icon] || icon;

    let tpl = Util.isNull(icon) ? 'notification.simple' : 'notification.icon',
        html = Template.fill(tpl, {text, icon}),
        $el = $(html),

        durationFx = 300,
        durationShow = 3000;

    $el.appendTo(Nodes.el.wrapOffscreen);

    // show
    setTimeout(() =>  $el.addClass(cls(config.sel.visible)), 100);
    // hide
    setTimeout(() => {
        $el.removeClass(cls(config.sel.visible));
        // remove
        setTimeout(() => $el.remove(), durationFx);
    }, durationShow + durationFx);
}

export default {
    show
}